"use client";

import { TextIntro as TextIntroComponent } from "@/composite/TextIntro";
import type { TextIntro } from "@/types/references";

type TextIntroBlockClientProps = Omit<TextIntro, "blockType">;

/**
 * Text Intro block component
 */
export function TextIntroBlock({
	text_intro_description,
	text_intro_heading_tag,
	text_intro_title
}: TextIntroBlockClientProps): JSX.Element {
	return (
		<TextIntroComponent
			heading={{
				children: text_intro_title,
				tag: text_intro_heading_tag
			}}
			description={text_intro_description}
		/>
	);
}
